import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useReservationsTopbarStore = defineStore('reservationsTopbar', () => {
    const headerTitle = ref('')
    const panelOpen   = ref(false)

    let _prev = null, _next = null, _openPicker = null

    function register({ prev, next, openPicker }) {
        _prev = prev
        _next = next
        _openPicker = openPicker
    }

    function unregister() {
        _prev = _next = _openPicker = null
        headerTitle.value = ''
    }

    function prev()        { _prev?.() }
    function next()        { _next?.() }
    function openPicker()  { _openPicker?.() }
    function openPanel()   { panelOpen.value = true }
    function closePanel()  { panelOpen.value = false }

    return { headerTitle, panelOpen, register, unregister, prev, next, openPicker, openPanel, closePanel }
})
